var _circle, _g, _g2, _circle2, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSvgPaloPointOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_189_41474)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFC875"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_189_41474)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.4999,
    cy: 12.5,
    r: 9.01163,
    fill: "#FF9F00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_189_41474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0232 7.55811C15.7596 7.55811 16.3991 7.68214 16.9418 7.9302C17.4844 8.17051 17.903 8.51935 18.1976 8.97671C18.4922 9.42632 18.6395 9.95733 18.6395 10.5697C18.6395 11.1821 18.4922 11.7131 18.1976 12.1628C17.903 12.6124 17.4844 12.9612 16.9418 13.2093C16.3991 13.4496 15.7596 13.5697 15.0232 13.5697H13.6046V17.4418H11.3022V7.55811H15.0232ZM14.8836 11.7558C15.3565 11.7558 15.7131 11.655 15.9534 11.4535C16.1937 11.2442 16.3139 10.9496 16.3139 10.5697C16.3139 10.1899 16.1937 9.89532 15.9534 9.68601C15.7131 9.47671 15.3565 9.37206 14.8836 9.37206H13.6046V11.7558H14.8836Z",
    fill: "#FFC875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.368 14.5349C16.6258 14.5349 16.8496 14.5783 17.0395 14.6651C17.2294 14.7492 17.3759 14.8713 17.479 15.0314C17.5821 15.1887 17.6337 15.3746 17.6337 15.5889C17.6337 15.8033 17.5821 15.9891 17.479 16.1465C17.3759 16.3038 17.2294 16.4259 17.0395 16.5128C16.8496 16.5969 16.6258 16.6389 16.368 16.6389H15.8715V17.4418H15.0657V14.5349H16.368ZM16.3192 16.004C16.4847 16.004 16.6095 15.9688 16.6936 15.8982C16.7777 15.825 16.8197 15.7219 16.8197 15.5889C16.8197 15.456 16.7777 15.3529 16.6936 15.2796C16.6095 15.2064 16.4847 15.1697 16.3192 15.1697H15.8715V16.004H16.3192Z",
    fill: "#FFC875"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_189_41474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 25,
    height: 25
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFC875"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_189_41474)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.877,
    y: -3.48834,
    width: 11.1444,
    height: 27.6787,
    transform: "rotate(48.1612 20.877 -3.48834)",
    fill: "url(#paint0_linear_189_41474)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0166,
    y: 6.97675,
    width: 11.1444,
    height: 27.6787,
    transform: "rotate(48.1612 29.0166 6.97675)",
    fill: "url(#paint1_linear_189_41474)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_189_41474",
    x: 0,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_189_41474"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_189_41474",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_189_41474",
    x: 5.48828,
    y: 3.4884,
    width: 18.0232,
    height: 18.0233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.790698
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_189_41474"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_189_41474",
    x: 9.72085,
    y: 5.97671,
    width: 10.4999,
    height: 13.0465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.790698
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_189_41474"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_189_41474",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_41474",
    x1: 26.4492,
    y1: -3.48834,
    x2: 26.4492,
    y2: 24.1903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FFF2DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_189_41474",
    x1: 34.5888,
    y1: 6.97675,
    x2: 34.5888,
    y2: 34.6554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FFF2DD",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSvgPaloPointOrange);
export default __webpack_public_path__ + "static/media/IconSVGPaloPointOrange.bbf31ac7.svg";
export { ForwardRef as ReactComponent };